module.exports = __webpack_public_path__ + "img/9623c3b.jpg";